module.exports = __webpack_public_path__ + "static/img/product_society_society_lxzz.68cbf91.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_lxzz.svg
// module id = jWOY
// module chunks = 0